module.exports = __webpack_public_path__ + "static/media/2C.960175f7.png";